import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

//时间生成
import mutations from "./mutations";
import actions from "./actions";

export default new Vuex.Store({
  state: {
	name:"",
	UserInfo:"",
	top:true,
	user:true,
	footer:true,
	banner:true,
  floatAd:true,
  fixedImg:true,
  fileLoading:true,
  progressNum:0,
	Name:""
  },
  getters: {
    UserInfo(state){
      return state.UserInfo;
    }
  },
  mutations: { //修改state的方法
    updateLoading(state, type) {
      state.vueElementLoading = type;
    },
    ...mutations
  },
  actions
});
